import React, { useState } from 'react';
import { Margin } from '@upgrade/react-components';
import { LOCALES, useLocale, useLocaleSwitcherExperiment } from '../../../utils/locale';
import MenuItem from '../HeaderMenu/menu-item';
import LocaleMenuLabel from './LocaleMenuLabel';
import LocaleSwitcherModal from './LocaleSwitcherModal';

const LocaleSwitcherMenuItem = ({ handleMenuClick, visibleSubMenuId }) => {
  const { locale: currentLocale } = useLocale();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedLocale, setSelectedLocale] = useState(currentLocale);
  const { isExperimentEnabled } = useLocaleSwitcherExperiment();

  if (!isExperimentEnabled) {
    return null;
  }

  const menuId = 'locale-switcher';
  const locales = Object.values(LOCALES);

  return (
    <>
      <MenuItem
        label={<LocaleMenuLabel locale={currentLocale} bold />}
        id={menuId}
        onClick={handleMenuClick?.(menuId)}
        visibleSubMenuId={visibleSubMenuId}
      >
        {locales.map(locale => {
          if (locale.code === currentLocale.code) {
            return null;
          }

          const handleLocaleClick = e => {
            setSelectedLocale(locale);
            handleMenuClick?.(menuId)(e);
            setModalVisible(true);
          };

          return (
            <Margin key={locale.code} top={{ xs: 'lg', md: 'none' }}>
              <LocaleMenuLabel locale={locale} onClick={handleLocaleClick} />
            </Margin>
          );
        })}
      </MenuItem>
      <LocaleSwitcherModal visible={modalVisible} onClose={() => setModalVisible(false)} locale={selectedLocale} />
    </>
  );
};

export default LocaleSwitcherMenuItem;
